import React from "react";
import { Card, Form, Row, Col, Badge } from "react-bootstrap";

const defaultNotificationSettings = {
  enabled: true,
  sendGuestConfirmationEmail: true,
  sendGuestModificationEmail: true,
  sendGuestCancellationEmail: true,
  sendTeamNewBookingEmail: true,
  teamRecipients: "",
  sendDailySummary: false,
  sendLowInventoryAlerts: false,
};

const NotificationSettings = ({ branding, setBranding }) => {
  const notificationSettings =
    branding.notificationSettings || defaultNotificationSettings;

  const updateSettings = (patch) => {
    setBranding((prev) => ({
      ...prev,
      notificationSettings: { ...notificationSettings, ...patch },
    }));
  };

  return (
    <Card className="p-4 border-0 shadow-sm">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="fw-bold mb-0">Notification Settings</h5>
          <small className="text-muted">
            Manage automated emails sent to guests and your property team.
          </small>
        </div>

        <Badge bg={notificationSettings.enabled ? "success" : "secondary"}>
          {notificationSettings.enabled ? "Enabled" : "Disabled"}
        </Badge>
      </div>

      <Form.Check
        type="switch"
        className="mb-4"
        id="notif-enabled"
        label={
          notificationSettings.enabled
            ? "Notifications enabled"
            : "Notifications disabled"
        }
        checked={notificationSettings.enabled}
        onChange={(e) => updateSettings({ enabled: e.target.checked })}
      />

      {!notificationSettings.enabled ? (
        <div className="text-muted small">
          Turn this ON to send booking emails and alerts.
        </div>
      ) : (
        <>
          {/* Guest Notifications */}
          <h6 className="fw-semibold mt-3 mb-2">Guest Notifications</h6>
          <Card className="p-3 mb-3 border-0 bg-light">
            <Form.Check
              type="switch"
              id="guest-confirm"
              label="Send Booking Confirmation Email"
              checked={notificationSettings.sendGuestConfirmationEmail}
              onChange={(e) =>
                updateSettings({ sendGuestConfirmationEmail: e.target.checked })
              }
            />
            <Form.Check
              type="switch"
              id="guest-modify"
              label="Send Booking Modification Email"
              checked={notificationSettings.sendGuestModificationEmail}
              onChange={(e) =>
                updateSettings({ sendGuestModificationEmail: e.target.checked })
              }
            />
            <Form.Check
              type="switch"
              id="guest-cancel"
              label="Send Cancellation Email"
              checked={notificationSettings.sendGuestCancellationEmail}
              onChange={(e) =>
                updateSettings({ sendGuestCancellationEmail: e.target.checked })
              }
            />
          </Card>

          {/* Team Notifications */}
          <h6 className="fw-semibold mb-2">Internal Team Notifications</h6>
          <Card className="p-3 mb-3 border-0 bg-light">
            <Form.Check
              type="switch"
              id="team-new"
              label="Send New Booking Email to Property Team"
              checked={notificationSettings.sendTeamNewBookingEmail}
              onChange={(e) =>
                updateSettings({ sendTeamNewBookingEmail: e.target.checked })
              }
            />

            <Form.Group className="mt-3">
              <Form.Label>Team Email Recipients</Form.Label>
              <Form.Control
                type="text"
                placeholder="manager@example.com, frontdesk@example.com"
                value={notificationSettings.teamRecipients}
                onChange={(e) =>
                  updateSettings({ teamRecipients: e.target.value })
                }
              />
              <small className="text-muted">
                Add multiple emails separated by commas.
              </small>
            </Form.Group>
          </Card>

          {/* Optional Automation */}
          <h6 className="fw-semibold mb-2">Optional Automations</h6>
          <Card className="p-3 border-0 bg-light">
            <Form.Check
              type="switch"
              id="daily-summary"
              label="Send Daily Booking Summary"
              checked={notificationSettings.sendDailySummary}
              onChange={(e) =>
                updateSettings({ sendDailySummary: e.target.checked })
              }
            />

            <Form.Check
              type="switch"
              id="low-inventory"
              label="Send Low Inventory Alerts"
              checked={notificationSettings.sendLowInventoryAlerts}
              onChange={(e) =>
                updateSettings({ sendLowInventoryAlerts: e.target.checked })
              }
            />
          </Card>
        </>
      )}
    </Card>
  );
};

export default NotificationSettings;
